const NATIVE_SPLASH_VISIBILITY_TYPE = "award-party:splash-visibility";

interface NativeSplashMessageBridge {
  postMessage(message: string): void;
}

interface NativeSplashGlobal {
  ReactNativeWebView?: NativeSplashMessageBridge;
}

export function postNativeSplashVisibility(visible: boolean): boolean {
  const bridge = (globalThis as NativeSplashGlobal).ReactNativeWebView;
  if (!bridge?.postMessage) {
    return false;
  }

  bridge.postMessage(
    JSON.stringify({
      type: NATIVE_SPLASH_VISIBILITY_TYPE,
      visible,
    }),
  );
  return true;
}
